import { useMemo } from 'react'
import { useFormatValue } from '../../hooks/useFormatValue'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'
import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
interface IFlightDateProps {
    date: string
    label: string
}
export const FlightDate = ({ date, label }: IFlightDateProps) => {
    const { formatValue } = useFormatValue()
    const { past } = useObjectContext()
    const icon = useMemo(() => {
        if (label?.includes('Arrival')) return 'Arrive'
        return 'Depart'
    }, [label])

    return (
        <Stack direction={'row'} gap={'8px'}>
            <Icon
                name={icon as any}
                iconColour={
                    past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary
                }
            />
            <CardText variant="bodyBold">{formatValue(date, 'date')}</CardText>
        </Stack>
    )
}
